import {
  Card,
  Icon,
  Text,
  TextField,
} from "@shopify/polaris";
import { HideIcon } from "@shopify/polaris-icons";
import { ViewIcon } from "@shopify/polaris-icons";
import { forgotPassword } from "../../dev_services/developer/api";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify"; // Import ToastContainer and toast

export default function DevSettings() {
  const [contactEmail, setContactEmail] = useState("");
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const [isNewPasswordVisible, setisNewPasswordVisible] = useState(false);
  const [isConfirmPasswordVisible, setisConfirmPasswordVisible] =
    useState(false);

  const [contactEmailError, setContactEmailError] = useState("");
  const [firstNameError, setFirstNameError] = useState("");
  const [lastNameError, setLastNameError] = useState("");

  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [oldPasswordError, setOldPasswordError] = useState("");
  const [newPasswordError, setNewPasswordError] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");
  const first_name = useSelector((state: any) => state.devAuth.dev_first_name);
  const last_name = useSelector((state: any) => state.devAuth.dev_last_name);
  const email = useSelector((state: any) => state.devAuth.dev_email);
  const partnerID = useSelector((state: any) => state.devAuth.dev_partner_id);
  // Function to toggle the visibility state
  const togglePasswordVisibility = () => {
    setIsPasswordVisible(!isPasswordVisible);
  };
  const toggleNewPasswordVisibility = () => {
    setisNewPasswordVisible(!isNewPasswordVisible);
  };
  const toggleConfirmPasswordVisibility = () => {
    setisConfirmPasswordVisible(!isConfirmPasswordVisible);
  };
  // Function to handle the update password API call
  const handleUpdatePassword = async () => {
    try {
      // Call the API here with the necessary data
      const response = await forgotPassword({
        email: email,
        old_password: oldPassword,
        password: newPassword,
        password_confirm: confirmPassword,
      });
      const responseMsg = response?.message;
      toast.success(responseMsg);
      console.log("response", responseMsg);
    } catch (error) {
      console.error("Error updating password:", error);
      toast.error("error occured");
    }
  };

  return (
    <div className="developer-page-frame">
      <ToastContainer style={{ paddingTop: "50px" }} />
      <div
        style={{ paddingLeft: "80px", paddingTop: "10px" }}
        className="container"
      >
        <div className='flex'>
          <div style={{ paddingTop: "20px", gap: "10px", display: 'flex' }}>

            <label style={{ fontFamily: "sfprobold", fontSize: "20px", lineHeight: "revert" }} className="font-medium text-base">
              Settings
            </label>
          </div>
        </div>
        <div className="pt-9 flex flex-col sm:flex-row gap-8">
          <label
            style={{ fontFamily: "sfpromedium", fontWeight: "400" }}
            className="font-medium text-base w-full sm:w-48"
          >
            Developer Details
          </label>{" "}
          <div
            className="w-full sm:w-2/3"
            style={{ pointerEvents: "none" }} // Disable pointer events using CSS
          >
            <Card>
              <div className="mb-4">
                <div style={{ padding: "20px" }}>
                  {/* Fields for First Name and Last Name */}
                  <div style={{ display: "flex", paddingBottom: "10px" }}>
                    <div style={{ flex: 1, paddingRight: "5px" }}>
                      <TextField
                        label={`First Name`}
                        autoComplete=""
                        placeholder="Your first name"
                        value={first_name}
                        onChange={(newValue) => {
                          setFirstNameError("");
                        }}
                      />
                      {firstNameError && (
                        <span style={{ color: "red" }}>{firstNameError}</span>
                      )}
                    </div>
                    <div style={{ flex: 1, paddingLeft: "5px" }}>
                      <TextField
                        label={`Last Name`}
                        autoComplete=""
                        placeholder="Your last name"
                        value={last_name}
                        onChange={(newValue) => {
                          setLastNameError("");
                        }}
                      />
                      {lastNameError && (
                        <span style={{ color: "red" }}>{lastNameError}</span>
                      )}
                    </div>
                  </div>

                  <div style={{ paddingTop: "10px" }}>
                    <TextField
                      label={`Developer email`}
                      autoComplete=""
                      placeholder="Email"
                      value={email}
                      onChange={(newValue) => {
                        setContactEmail(newValue);
                        setContactEmailError("");
                      }}
                    />
                    {contactEmailError && (
                      <span style={{ color: "red" }}>{contactEmailError}</span>
                    )}
                  </div>

                  <div style={{ paddingTop: "10px" }}>
                    <TextField
                      label={`Partner ID`}
                      autoComplete=""
                      placeholder="Partner ID"
                      value={partnerID}
                      onChange={(newValue) => {
                        setContactEmail(newValue);
                        setContactEmailError("");
                      }}
                    />
                  </div>
                </div>
              </div>
            </Card>
          </div>
        </div>
      </div>
      <div
        style={{ paddingLeft: "80px", paddingTop: "10px", paddingBottom: "30px" }}

      >
        <div className="pt-9 flex flex-col sm:flex-row gap-8">
          <label
            style={{ fontFamily: "sfpromedium", fontWeight: "400" }}
            className="font-medium text-base w-full sm:w-48"
          >
            Update Password
          </label>{" "}
          <div className="w-full sm:w-2/3">
            <Card>
              <div >
                <div style={{ paddingTop: "20px", paddingLeft: "20px", paddingRight: "20px" }}>
                  <TextField
                    label="Old Password"
                    autoComplete=""
                    type={isPasswordVisible ? "text" : "password"} // Toggle the input type
                    value={oldPassword}
                    onChange={(newValue) => {
                      setOldPassword(newValue);
                      setOldPasswordError("");
                    }}
                    placeholder="Old Password"
                    suffix={
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <a
                          href="/your-first-link"
                          onClick={(e) => {
                            e.preventDefault();
                            togglePasswordVisibility();
                          }}
                        >
                          <Icon
                            source={isPasswordVisible ? ViewIcon : HideIcon}
                            tone="base"
                          />
                        </a>
                      </div>
                    }
                  />
                  {oldPasswordError && (
                    <span style={{ color: "red" }}>{oldPasswordError}</span>
                  )}

                  <div style={{ paddingTop: "10px" }}>
                    <TextField
                      label="New Password"
                      autoComplete=""
                      type={isNewPasswordVisible ? "text" : "password"} // Toggle the input type
                      value={newPassword}
                      onChange={(newValue) => {
                        setNewPassword(newValue);
                        setNewPasswordError("");
                      }}
                      placeholder="New Password"
                      suffix={
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <a
                            href="/your-first-link"
                            onClick={(e) => {
                              e.preventDefault();
                              toggleNewPasswordVisibility();
                            }}
                          >
                            <Icon
                              source={
                                isNewPasswordVisible ? ViewIcon : HideIcon
                              }
                              tone="base"
                            />
                          </a>
                        </div>
                      }
                    />
                    {newPasswordError && (
                      <span style={{ color: "red" }}>{newPasswordError}</span>
                    )}
                  </div>

                  <div style={{ paddingTop: "10px" }}>
                    <TextField
                      label="Confirm Password"
                      autoComplete=""
                      type={isConfirmPasswordVisible ? "text" : "password"} // Toggle the input type
                      value={confirmPassword}
                      onChange={(newValue) => {
                        setConfirmPassword(newValue);
                        setConfirmPasswordError("");
                      }}
                      placeholder="Confirm Password"
                      suffix={
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <a
                            href="/your-first-link"
                            onClick={(e) => {
                              e.preventDefault();
                              toggleConfirmPasswordVisibility();
                            }}
                          >
                            <Icon
                              source={
                                isConfirmPasswordVisible ? ViewIcon : HideIcon
                              }
                              tone="base"
                            />
                          </a>
                        </div>
                      }
                    />
                    {confirmPasswordError && (
                      <span style={{ color: "red" }}>
                        {confirmPasswordError}
                      </span>
                    )}
                  </div>
                  <div className="flex justify-end mt-6">
                    <button
                      type="submit"
                      className="button"
                      onClick={handleUpdatePassword}
                    >
                      <Text variant="bodyMd" as="p">
                        Update Password
                      </Text>
                    </button>
                  </div>
                </div>
              </div>
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
}
